import React from 'react';
import { DataGrid, GridColDef, GridPanelProps } from '@mui/x-data-grid';
import { Button, Container, Box, Grid, Typography, Paper, Stack } from '@mui/material';



import * as Api from "api/api"
import * as UsersApi from 'api/users'

import UserDetailsTab from "./UserDetailsTab"
import ErrorMessage from 'tsui/ErrorMessage'

import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

export default function UsersTab() {

    const mounted = React.useRef(false);
    let [dataRequested, setDataRequested] = React.useState(false);
    let [error, setError] = React.useState<Error | null>(null);
    let [users, setUsers] = React.useState<UsersApi.ApiUser[]>();
    let [userDetailsId, setUserDetailsId] = React.useState<string | null>(null);

    let [showAddUser, setShowAddUser] = React.useState(false);

    const [searchVal, setSearchVal] = React.useState('');


    React.useEffect(() => {
        mounted.current = true;
        if (!dataRequested) {
            Api.requestAdmin<UsersApi.ApiUser[]>('users', 'fetch', { searchVal: searchVal === '' ? 'empty' : searchVal }).then(users => {
                if (mounted.current) {
                    console.log('users', users)
                    setUsers(users);
                }
            }).catch(setError);
            setDataRequested(true);
            return;
        }
        return () => { mounted.current = false }
    }, [dataRequested]);


    if (error) {
        console.debug(error);
        return <ErrorMessage error={error} />
    }

    if (!users) {
        return <></>
    }

    console.log('userDetailsId', userDetailsId)
    /*
    function RenderUser(user: UsersApi.ApiUser, index: number) {
        return <tr key={index}>
            <td>{user.userId}</td>
            <td>{user.firstName}</td>
            <td>{user.lastName}</td>
            <td>{user.email}</td>
            <td>{user.phone}</td>
            <td>
                <Button onClick={() => setShownUserIndex(index)}>Details</Button>
                <Button onClick={() => setEditedUserIndex(index)}>Edit</Button>
            </td>
        </tr>
    }
    */


    return <>
        <Stack direction='column' height='100%' alignItems='center' spacing={2}>
            <Stack direction='row' width='100%' spacing={2} alignItems='center'>
                <Typography>Total Users:&nbsp;{users.length}</Typography>


                <Paper
                    component="form"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                >
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search"
                        inputProps={{ 'aria-label': 'search google maps' }}
                        onChange={e => setSearchVal(e.target.value)}
                        value={searchVal}
                    />
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                        <SearchIcon />
                    </IconButton>
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    <Button onClick={() => setDataRequested(false)}>
                        {/* <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions"> */}
                        <DirectionsIcon />
                        {/* </IconButton> */}
                    </Button>
                </Paper>

                {/* <Button variant='outlined' onClick={() => { setShowAddUser(true) }}>Add User</Button> */}
            </Stack>



                <DataGrid
                    sx={{
                        width: '100%',
                        color: theme_.dataGridTextColor
                    }}
                    columns={[
                        { field: 'userId', headerName: 'User Id', headerAlign: 'center', width: 80 },
                        { field: 'firstName', headerName: 'First Name', headerAlign: 'center', width: 120 },
                        { field: 'lastName', headerName: 'Last Name', headerAlign: 'center', width: 120 },
                        { field: 'email', headerName: 'Email', headerAlign: 'center', minWidth: 300, flex: 1 }, // width: 600 },
                        { field: 'cardInfo', headerName: 'Cards', headerAlign: 'center', minWidth: 80, flex: 1 },

                        {
                            field: '', type: 'actions', headerName: 'Actions', width: 100, renderCell: (cell) => {
                                return <>
                                    <Button variant='contained' onClick={() => setUserDetailsId(cell.id as string)}>Details</Button>
                                    {/* <Button onClick={() => setEditedUserIndex(cell.id as string)}>Edit</Button> */}
                                </>;
                            }
                        }, // width: 600 },
                    ]}
                    rows={users}
                    //pageSize={10}
                    //autoHeight
                    //rowsPerPageOptions={[10]}

                    autoPageSize={true}
                    disableRowSelectionOnClick
                    getRowId={row => row.userId}
                />
        </Stack>


        {userDetailsId && <UserDetailsTab userId={userDetailsId} onClose={() => { setUserDetailsId(null); setDataRequested(false) }} />}
        {/* {editedUserIndex && <EditUserDialog user={users![editedUserIndex]} onClose={() => setEditedUserIndex(null)} />} */}
    </>;
}


